"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.NotFound = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const prop_types_1 = __importDefault(require("prop-types"));
const react_jss_1 = __importDefault(require("react-jss"));
const icon_1 = __importDefault(require("./icon"));
const pushbutton_1 = __importDefault(require("../pushbutton"));
const notFound_style_1 = __importDefault(require("./notFound.style"));
const NotFound = ({ classes, onHomeClick }) => (jsx_runtime_1.jsxs("div", Object.assign({ className: classes.root }, { children: [jsx_runtime_1.jsx(icon_1.default, { className: classes.icon }, void 0),
        jsx_runtime_1.jsx("p", { children: "Sorry, we can't find the page you're looking for." }, void 0),
        jsx_runtime_1.jsx("div", Object.assign({ className: classes.btn }, { children: jsx_runtime_1.jsx(pushbutton_1.default, Object.assign({ primary: true, onClick: onHomeClick }, { children: "Take me home" }), void 0) }), void 0)] }), void 0));
exports.NotFound = NotFound;
exports.NotFound.propTypes = {
    classes: prop_types_1.default.object.isRequired,
    onHomeClick: prop_types_1.default.func.isRequired
};
exports.default = react_jss_1.default(notFound_style_1.default)(exports.NotFound);
//# sourceMappingURL=notFound.js.map